import React, { createContext, useState, useContext } from 'react';

const translations = {
  ENG: {
    welcomeMessage: "Welcome, Admin! 👋",
    searchPlaceholder: "Search packages, couriers, or tracking IDs...",
    searchButton: "Search",
    totalShipments: "Total Shipments",
    fromLastWeek: "from last week",
    activeCouriers: "Active Couriers",
    newThisWeek: "new this week",
    revenue: "Revenue",
    fromLastMonth: "from last month",
    completionRate: "Completion Rate",
    improvement: "improvement",
    shipmentTrends: "Shipment Trends",
    daily: "daily",
    weekly: "weekly",
    monthly: "monthly",
    successfulDeliveries: "Successful Deliveries",
    avgPackagesDelivered: "Avg Packages Delivery",
    topCouriers: "Top Couriers",
    deliveries: "deliveries",
    recentActivity: "Recent Activity",
    myProfileTitle: "My Profile",
    myProfileSubtitle: "Manage your account information and preferences",
    admin: "Admin",
    lastLogin: "Last Login",
    accountStatus: "Account Status",
    languagePreference: "Language Preference",
    editProfile: "Edit Profile",
    changePassword: "Change Password",
    personalInformation: "Personal Information",
    cancel: "Cancel",
    fullName: "Full Name",
    email: "Email",
    phone: "Phone",
    address: "Address",
    save: "Save",
    securitySettings: "Security Settings",
    twoFactorAuth: "Two-Factor Authentication",
    logoutAllDevices: "Log out of all devices",
    preferences: "Preferences",
    emailNotifications: "Email Notifications",
    systemNotifications: "System Notifications",
    notificationSettings: "Notification Settings",
    deliveryUpdates: "Delivery Updates",
    paymentAlerts: "Payment Alerts",
    systemAlerts: "System Alerts",
    courierUpdates: "Courier Updates",
    activityLog: "Activity Log",
    loggedIn: "Logged in",
    viewedAnalytics: "Viewed analytics",
    updatedProfile: "Updated profile",
    settingsTitle: "Settings",
    settingsSubtitle: "Manage system configuration and platform preferences",
    settingsUpdated: "Settings successfully updated",
    generalSettings: "General Settings",
    platformName: "Platform Name",
    defaultLanguage: "Default Language",
    timeZone: "Time Zone",
    dateTimeFormat: "Date & Time Format",
    userManagement: "User Management",
    allowCourierRegistration: "Allow new courier registration",
    defaultCourierStatus: "Default courier status",
    addNewAdmin: "Add New Admin",
    deliveryRouting: "Delivery & Routing",
    defaultDeliveryPriority: "Default delivery priority",
    normal: "Normal",
    urgent: "Urgent",
    enableTrafficRouting: "Enable traffic-based routing",
    etaCalculationMode: "ETA calculation mode",
    static: "Static",
    dynamic: "Dynamic",
    maxDeliveryRadius: "Max delivery radius",
    notificationSettingsSystem: "Notification Settings",
    enableSystemNotifications: "Enable system notifications",
    enableEmailAlerts: "Enable email alerts",
    paymentNotifications: "Payment notifications",
    deliveryStatusAlerts: "Delivery status alerts",
    securitySettingsSystem: "Security Settings",
    minimumLength: "Minimum password length",
    sessionTimeout: "Session timeout",
    specialCharsRequired: "Special characters required",
    enable2FA: "Enable 2FA",
    dataStorage: "Data & Storage Settings",
    dataRetentionPeriod: "Data retention period",
    backupFrequency: "Backup frequency",
    exportData: "Export Data",
    apiIntegration: "API & Integration Settings",
    openStreetMapAPI: "OpenStreetMap API status",
    connected: "Connected",
    trafficAPI: "Traffic API",
    apiKey: "API key",
    testConnection: "Test Connection",
    vehicleFleet: "Vehicle & Fleet Settings",
    enableVehicleTracking: "Enable vehicle tracking",
    maintenanceAlerts: "Maintenance alerts",
    saveChanges: "Save Changes",
    addPackage: "Add Package",
    editWarehouse: "Edit warehouse",
    packageDetails: "Package Details",
    notificationsTitle: "Notifications",
    notificationsSubtitle: "Stay updated with your logistics operations",
    markAllRead: "Mark all as read",
    all: "All",
    alerts: "Alerts",
    payments: "Payments",
    viewAllNotifications: "View All Notifications",
    recentNotifications: "Recent Notifications",
  },
  AZE: {
    welcomeMessage: "Xoş gəlmisiniz, Admin! 👋",
    searchPlaceholder: "Bağlamaları, kuryerləri və ya izləmə ID-lərini axtarın...",
    searchButton: "Axtar",
    totalShipments: "Ümumi Bağlamalar",
    fromLastWeek: "keçən həftədən",
    activeCouriers: "Aktiv Kuryerlər",
    newThisWeek: "bu həftə yeni",
    revenue: "Gəlir",
    fromLastMonth: "keçən aydan",
    completionRate: "Tamamlanma Dərəcəsi",
    improvement: "irəliləyiş",
    shipmentTrends: "Bağlama Trendləri",
    daily: "günlük",
    weekly: "həftəlik",
    monthly: "aylıq",
    successfulDeliveries: "Uğurlu Çatdırılmalar",
    avgPackagesDelivered: "Orta Çatdırılan Bağlamalar",
    topCouriers: "Top Kuryerlər",
    deliveries: "çatdırılma",
    recentActivity: "Son Fəaliyyət",
    myProfileTitle: "Mənim Profilim",
    myProfileSubtitle: "Hesab məlumatlarınızı və seçimlərinizi idarə edin",
    admin: "Admin",
    lastLogin: "Son Giriş",
    accountStatus: "Hesab Statusu",
    languagePreference: "Dil Seçimi",
    editProfile: "Profili Redaktə Et",
    changePassword: "Şifrəni Dəyiş",
    personalInformation: "Şəxsi Məlumat",
    cancel: "Ləğv et",
    fullName: "Tam Ad",
    email: "E-poçt",
    phone: "Telefon",
    address: "Ünvan",
    save: "Yadda saxla",
    securitySettings: "Təhlükəsizlik Parametrləri",
    twoFactorAuth: "İkimərhələli Doğrulama",
    logoutAllDevices: "Bütün cihazlardan çıx",
    preferences: "Seçimlər",
    emailNotifications: "E-poçt Bildirişləri",
    systemNotifications: "Sistem Bildirişləri",
    notificationSettings: "Bildiriş Parametrləri",
    deliveryUpdates: "Çatdırılma Yeniləmələri",
    paymentAlerts: "Ödəniş Bildirişləri",
    systemAlerts: "Sistem Bildirişləri",
    courierUpdates: "Kuryer Yeniləmələri",
    activityLog: "Fəaliyyət Jurnalı",
    loggedIn: "Daxil olub",
    viewedAnalytics: "Analitikaya baxıb",
    updatedProfile: "Profil yenilənib",
    settingsTitle: "Parametrlər",
    settingsSubtitle: "Sistem konfiqurasiyasını və platforma seçimlərini idarə edin",
    settingsUpdated: "Parametrlər uğurla yeniləndi",
    generalSettings: "Ümumi Parametrlər",
    platformName: "Platforma Adı",
    defaultLanguage: "Standart Dil",
    timeZone: "Saat Qurşağı",
    dateTimeFormat: "Tarix və Saat Formatı",
    userManagement: "İstifadəçi İdarəetməsi",
    allowCourierRegistration: "Yeni kuryer qeydiyyatına icazə ver",
    defaultCourierStatus: "Standart kuryer statusu",
    addNewAdmin: "Yeni Admin Əlavə Et",
    deliveryRouting: "Çatdırılma və Marşrutlaşdırma",
    defaultDeliveryPriority: "Standart çatdırılma prioriteti",
    normal: "Normal",
    urgent: "Təcili",
    enableTrafficRouting: "Trafik əsaslı marşrutlaşdırmanı aktiv et",
    etaCalculationMode: "ETA hesablama rejimi",
    static: "Statik",
    dynamic: "Dinamik",
    maxDeliveryRadius: "Maksimum çatdırılma radiusu",
    notificationSettingsSystem: "Bildiriş Parametrləri",
    enableSystemNotifications: "Sistem bildirişlərini aktiv et",
    enableEmailAlerts: "E-poçt bildirişlərini aktiv et",
    paymentNotifications: "Ödəniş bildirişləri",
    deliveryStatusAlerts: "Çatdırılma statusu bildirişləri",
    securitySettingsSystem: "Təhlükəsizlik Parametrləri",
    minimumLength: "Minimum şifrə uzunluğu",
    sessionTimeout: "Sessiya fasiləsi",
    specialCharsRequired: "Xüsusi simvollar tələb olunur",
    enable2FA: "2FA aktiv et",
    dataStorage: "Məlumat və Yaddaş Parametrləri",
    dataRetentionPeriod: "Məlumat saxlama müddəti",
    backupFrequency: "Yedəkləmə tezliyi",
    exportData: "Məlumatı İxrac Et",
    apiIntegration: "API və İnteqrasiya Parametrləri",
    openStreetMapAPI: "OpenStreetMap API statusu",
    connected: "Qoşulub",
    trafficAPI: "Trafik API",
    apiKey: "API açarı",
    testConnection: "Bağlantını Yoxla",
    vehicleFleet: "Avtomobil və Donanma Parametrləri",
    enableVehicleTracking: "Avtomobil izləməsini aktiv et",
    maintenanceAlerts: "Baxım bildirişləri",
    saveChanges: "Dəyişiklikləri Yadda Saxla",
    addPackage: "Bağlama əlavə et",
    editWarehouse: "Anbarı redaktə et",
    packageDetails: "Bağlama Məlumatları",
    notificationsTitle: "Bildirişlər",
    notificationsSubtitle: "Logistika əməliyyatlarınızla bağlı ən son yeniliklərdən xəbərdar olun",
    markAllRead: "Hamısını oxunmuş kimi qeyd et",
    all: "Hamısı",
    alerts: "Xəbərdarlıqlar",
    payments: "Ödənişlər",
    viewAllNotifications: "Bütün Bildirişlərə Bax",
    recentNotifications: "Son Bildirişlər",
  },
  RUS: {
    welcomeMessage: "Добро пожаловать, Админ! 👋",
    searchPlaceholder: "Поиск посылок, курьеров или ID отслеживания...",
    searchButton: "Поиск",
    totalShipments: "Всего посылок",
    fromLastWeek: "с прошлой недели",
    activeCouriers: "Активные курьеры",
    newThisWeek: "новые на этой неделе",
    revenue: "Доход",
    fromLastMonth: "с прошлого месяца",
    completionRate: "Уровень завершения",
    improvement: "улучшение",
    shipmentTrends: "Тренды поставок",
    daily: "ежедневно",
    weekly: "еженедельно",
    monthly: "ежемесячно",
    successfulDeliveries: "Успешные доставки",
    avgPackagesDelivered: "Среднее кол-во посылок",
    topCouriers: "Лучшие курьеры",
    deliveries: "доставок",
    recentActivity: "Последняя активность",
    myProfileTitle: "Мой профиль",
    myProfileSubtitle: "Управляйте информацией вашего аккаунта и предпочтениями",
    admin: "Админ",
    lastLogin: "Последний вход",
    accountStatus: "Статус аккаунта",
    languagePreference: "Выбор языка",
    editProfile: "Редактировать профиль",
    changePassword: "Изменить пароль",
    personalInformation: "Личная информация",
    cancel: "Отмена",
    fullName: "Полное имя",
    email: "Электронная почта",
    phone: "Телефон",
    address: "Адрес",
    save: "Сохранить",
    securitySettings: "Настройки безопасности",
    twoFactorAuth: "Двухфакторная аутентификация",
    logoutAllDevices: "Выйти со всех устройств",
    preferences: "Предпочтения",
    emailNotifications: "Уведомления по электронной почте",
    systemNotifications: "Системные уведомления",
    notificationSettings: "Настройки уведомлений",
    deliveryUpdates: "Обновления доставки",
    paymentAlerts: "Уведомления об оплате",
    systemAlerts: "Системные уведомления",
    courierUpdates: "Обновления курьеров",
    activityLog: "Журнал активности",
    loggedIn: "Вошел в систему",
    viewedAnalytics: "Просмотрел аналитику",
    updatedProfile: "Профиль обновлен",
    settingsTitle: "Настройки",
    settingsSubtitle: "Управление конфигурацией системы и настройками платформы",
    settingsUpdated: "Настройки успешно обновлены",
    generalSettings: "Общие настройки",
    platformName: "Название платформы",
    defaultLanguage: "Язык по умолчанию",
    timeZone: "Часовой пояс",
    dateTimeFormat: "Формат даты и времени",
    userManagement: "Управление пользователями",
    allowCourierRegistration: "Разрешить регистрацию новых курьеров",
    defaultCourierStatus: "Статус курьера по умолчанию",
    addNewAdmin: "Добавить нового админа",
    deliveryRouting: "Доставка и маршрутизация",
    defaultDeliveryPriority: "Приоритет доставки по умолчанию",
    normal: "Обычный",
    urgent: "Срочный",
    enableTrafficRouting: "Включить маршрутизацию с учетом трафика",
    etaCalculationMode: "Режим расчета времени прибытия",
    static: "Статический",
    dynamic: "Динамический",
    maxDeliveryRadius: "Максимальный радиус доставки",
    notificationSettingsSystem: "Настройки уведомлений",
    enableSystemNotifications: "Включить системные уведомления",
    enableEmailAlerts: "Включить оповещения по электронной почте",
    paymentNotifications: "Уведомления об оплате",
    deliveryStatusAlerts: "Оповещения о статусе доставки",
    securitySettingsSystem: "Настройки безопасности",
    minimumLength: "Минимальная длина пароля",
    sessionTimeout: "Тайм-аут сессии",
    specialCharsRequired: "Требуются специальные символы",
    enable2FA: "Включить 2FA",
    dataStorage: "Настройки данных и хранилища",
    dataRetentionPeriod: "Период хранения данных",
    backupFrequency: "Частота резервного копирования",
    exportData: "Экспорт данных",
    apiIntegration: "Настройки API и интеграции",
    openStreetMapAPI: "Статус API OpenStreetMap",
    connected: "Подключено",
    trafficAPI: "Traffic API",
    apiKey: "Ключ API",
    testConnection: "Проверить соединение",
    vehicleFleet: "Настройки транспорта и автопарка",
    enableVehicleTracking: "Включить отслеживание транспорта",
    maintenanceAlerts: "Оповещения о техническом обслуживании",
    saveChanges: "Сохранить изменения",
    addPackage: "Добавить посылку",
    editWarehouse: "Редактировать склад",
    packageDetails: "Детали посылки",
    notificationsTitle: "Уведомления",
    notificationsSubtitle: "Оставайтесь в курсе ваших логистических операций",
    markAllRead: "Отметить все как прочитанные",
    all: "Все",
    alerts: "Оповещения",
    payments: "Платежи",
    viewAllNotifications: "Просмотреть все уведомления",
    recentNotifications: "Последние уведомления",
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('ENG');

  const value = {
    language,
    setLanguage,
    t: translations[language]
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
